// PayArc Approved MCC Codes
export interface SicCode {
  code: string;
  description: string;
}

export const PAYARC_SIC_CODES: SicCode[] = [
  { code: "4121", description: "Taxicabs and Limousines" },
  { code: "4214", description: "Motor Freight Carriers" },
  { code: "4215", description: "Courier Services - Air and Ground" },
  { code: "4225", description: "Public Warehousing and Storage" },
  { code: "4411", description: "Cruise Lines" },
  { code: "4457", description: "Boat Rentals and Leases" },
  { code: "4468", description: "Marinas, Service and Supplies" },
  { code: "4511", description: "Airlines, Air Carriers" },
  { code: "4582", description: "Airports, Flying Fields, and Airport Terminals" },
  { code: "4722", description: "Travel Agencies, Tour Operators" },
  { code: "4784", description: "Tolls/Bridge Fees" },
  { code: "4789", description: "Transportation Services - Not Elsewhere Classified" },
  { code: "4812", description: "Telecommunication Equipment and Telephone Sales" },
  { code: "4814", description: "Telecommunication Services" },
  { code: "4815", description: "Monthly Summary Telephone Charges" },
  { code: "4816", description: "Computer Network Services" },
  { code: "4821", description: "Telegraph Services" },
  { code: "4829", description: "Wires, Money Orders" },
  { code: "4899", description: "Cable and Other Pay Television Services" },
  { code: "4900", description: "Utilities" },
  { code: "5013", description: "Motor Vehicle Supplies and New Parts" },
  { code: "5021", description: "Office and Commercial Furniture" },
  { code: "5039", description: "Construction Materials - Not Elsewhere Classified" },
  { code: "5044", description: "Photographic, Photocopy, Microfilm Equipment, and Supplies" },
  { code: "5045", description: "Computers, Computer Peripheral Equipment, Software" },
  { code: "5046", description: "Commercial Equipment - Not Elsewhere Classified" },
  { code: "5047", description: "Medical, Dental, Ophthalmic, and Hospital Equipment and Supplies" },
  { code: "5051", description: "Metal Service Centers" },
  { code: "5065", description: "Electrical Parts and Equipment" },
  { code: "5072", description: "Hardware, Equipment and Supplies" },
  { code: "5074", description: "Plumbing and Heating Equipment and Supplies" },
  { code: "5085", description: "Industrial Supplies - Not Elsewhere Classified" },
  { code: "5094", description: "Precious Stones and Metals, Watches and Jewelry" },
  { code: "5099", description: "Durable Goods - Not Elsewhere Classified" },
  { code: "5111", description: "Stationery, Office Supplies, Printing and Writing Paper" },
  { code: "5122", description: "Drugs, Drug Proprietaries, and Druggist Sundries" },
  { code: "5131", description: "Piece Goods, Notions, and Other Dry Goods" },
  { code: "5137", description: "Men's, Women's, and Children's Uniforms and Commercial Clothing" },
  { code: "5139", description: "Commercial Footwear" },
  { code: "5169", description: "Chemicals and Allied Products - Not Elsewhere Classified" },
  { code: "5172", description: "Petroleum and Petroleum Products" },
  { code: "5192", description: "Books, Periodicals, and Newspapers" },
  { code: "5193", description: "Florists' Supplies, Nursery Stock, and Flowers" },
  { code: "5198", description: "Paints, Varnishes, and Supplies" },
  { code: "5199", description: "Nondurable Goods - Not Elsewhere Classified" },
  { code: "5200", description: "Home Supply Warehouse Stores" },
  { code: "5211", description: "Lumber, Building Materials Stores" },
  { code: "5231", description: "Glass, Paint, and Wallpaper Stores" },
  { code: "5251", description: "Hardware Stores" },
  { code: "5261", description: "Nurseries, Lawn and Garden Supply Stores" },
  { code: "5271", description: "Mobile Home Dealers" },
  { code: "5300", description: "Wholesale Clubs" },
  { code: "5309", description: "Duty Free Stores" },
  { code: "5310", description: "Discount Stores" },
  { code: "5311", description: "Department Stores" },
  { code: "5331", description: "Variety Stores" },
  { code: "5399", description: "Miscellaneous General Merchandise" },
  { code: "5411", description: "Grocery Stores, Supermarkets" },
  { code: "5422", description: "Freezer and Locker Meat Provisioners" },
  { code: "5441", description: "Candy, Nut, and Confectionery Stores" },
  { code: "5451", description: "Dairy Products Stores" },
  { code: "5462", description: "Bakeries" },
  { code: "5499", description: "Miscellaneous Food Stores - Convenience Stores and Specialty Markets" },
  { code: "5511", description: "Car and Truck Dealers (New & Used) Sales, Service, Repairs Parts and Leasing" },
  { code: "5521", description: "Car and Truck Dealers (Used Only) Sales, Service, Repairs Parts and Leasing" },
  { code: "5531", description: "Auto and Home Supply Stores" },
  { code: "5532", description: "Automotive Tire Stores" },
  { code: "5533", description: "Automotive Parts and Accessories Stores" },
  { code: "5541", description: "Service Stations" },
  { code: "5542", description: "Automated Fuel Dispensers" },
  { code: "5551", description: "Boat Dealers" },
  { code: "5561", description: "Recreational Vehicle Dealers" },
  { code: "5571", description: "Motorcycle Shops and Dealers" },
  { code: "5592", description: "Motor Homes Dealers" },
  { code: "5598", description: "Snowmobile Dealers" },
  { code: "5599", description: "Miscellaneous Auto Dealers" },
  { code: "5611", description: "Men's and Boys' Clothing and Accessories Stores" },
  { code: "5621", description: "Women's Ready-To-Wear Stores" },
  { code: "5631", description: "Women's Accessory and Specialty Shops" },
  { code: "5641", description: "Children's and Infants' Wear Stores" },
  { code: "5651", description: "Family Clothing Stores" },
  { code: "5655", description: "Sports and Riding Apparel Stores" },
  { code: "5661", description: "Shoe Stores" },
  { code: "5681", description: "Furriers and Fur Shops" },
  { code: "5691", description: "Men's and Women's Clothing Stores" },
  { code: "5697", description: "Tailors, Alterations" },
  { code: "5698", description: "Wig and Toupee Shops" },
  { code: "5699", description: "Miscellaneous Apparel and Accessory Shops" },
  { code: "5712", description: "Furniture, Home Furnishings, and Equipment Stores, Except Appliances" },
  { code: "5713", description: "Floor Covering Stores" },
  { code: "5714", description: "Drapery, Window Covering, and Upholstery Stores" },
  { code: "5718", description: "Fireplace, Fireplace Screens, and Accessories Stores" },
  { code: "5719", description: "Miscellaneous Home Furnishing Specialty Stores" },
  { code: "5722", description: "Household Appliance Stores" },
  { code: "5732", description: "Electronics Stores" },
  { code: "5733", description: "Music Stores-Musical Instruments, Pianos, and Sheet Music" },
  { code: "5734", description: "Computer Software Stores" },
  { code: "5735", description: "Record Stores" },
  { code: "5811", description: "Caterers" },
  { code: "5812", description: "Eating Places, Restaurants" },
  { code: "5813", description: "Drinking Places (Alcoholic Beverages) - Bars, Taverns, Cocktail Lounges" },
  { code: "5814", description: "Fast Food Restaurants" },
  { code: "5815", description: "Digital Goods Media - Books, Movies, Music" },
  { code: "5816", description: "Digital Goods - Games" },
  { code: "5817", description: "Digital Goods - Applications (Excludes Games)" },
  { code: "5818", description: "Digital Goods - Large Digital Goods Merchant" },
  { code: "5912", description: "Drug Stores and Pharmacies" },
  { code: "5921", description: "Package Stores-Beer, Wine, and Liquor" },
  { code: "5931", description: "Used Merchandise and Secondhand Stores" },
  { code: "5932", description: "Antique Shops" },
  { code: "5933", description: "Pawn Shops" },
  { code: "5937", description: "Antique Reproductions" },
  { code: "5940", description: "Bicycle Shops" },
  { code: "5941", description: "Sporting Goods Stores" },
  { code: "5942", description: "Book Stores" },
  { code: "5943", description: "Stationery, Office Supplies, Printing and Writing Paper" },
  { code: "5944", description: "Jewelry Stores, Watches, Clocks, and Silverware Stores" },
  { code: "5945", description: "Hobby, Toy, and Game Shops" },
  { code: "5946", description: "Camera and Photographic Supply Stores" },
  { code: "5947", description: "Gift, Card, Novelty, and Souvenir Shops" },
  { code: "5948", description: "Luggage and Leather Goods Stores" },
  { code: "5949", description: "Sewing, Needlework, Fabric, and Piece Goods Stores" },
  { code: "5950", description: "Glassware, Crystal Stores" },
  { code: "5960", description: "Direct Marketing - Insurance Services" },
  { code: "5962", description: "Direct Marketing - Travel" },
  { code: "5963", description: "Door-To-Door Sales" },
  { code: "5964", description: "Direct Marketing - Catalog Merchant" },
  { code: "5965", description: "Direct Marketing - Combination Catalog and Retail Merchant" },
  { code: "5966", description: "Direct Marketing - Outbound Telemarketing" },
  { code: "5967", description: "Direct Marketing - Inbound Teleservices" },
  { code: "5968", description: "Direct Marketing - Continuity/Subscription Merchants" },
  { code: "5969", description: "Direct Marketing - Not Elsewhere Classified" },
  { code: "5970", description: "Artist's Supply and Craft Shops" },
  { code: "5971", description: "Art Dealers and Galleries" },
  { code: "5972", description: "Stamp and Coin Stores" },
  { code: "5973", description: "Religious Goods Stores" },
  { code: "5975", description: "Hearing Aids Sales and Supplies" },
  { code: "5976", description: "Orthopedic Goods - Prosthetic Devices" },
  { code: "5977", description: "Cosmetic Stores" },
  { code: "5978", description: "Typewriter Stores" },
  { code: "5983", description: "Fuel Dealers (Non Automotive)" },
  { code: "5992", description: "Florists" },
  { code: "5993", description: "Cigar Stores and Stands" },
  { code: "5994", description: "News Dealers and Newsstands" },
  { code: "5995", description: "Pet Shops, Pet Food, and Supplies" },
  { code: "5996", description: "Swimming Pools Sales" },
  { code: "5997", description: "Electric Razor Stores" },
  { code: "5998", description: "Tent and Awning Shops" },
  { code: "5999", description: "Miscellaneous Specialty Retail" },
  { code: "6010", description: "Manual Cash Disburse" },
  { code: "6011", description: "Automated Cash Disburse" },
  { code: "6012", description: "Financial Institutions" },
  { code: "6051", description: "Non-FI, Money Orders" },
  { code: "6211", description: "Security Brokers, Dealers" },
  { code: "6300", description: "Insurance Underwriting, Premiums" },
  { code: "6381", description: "Insurance - Premiums" },
  { code: "6399", description: "Insurance - Not Elsewhere Classified" },
  { code: "6513", description: "Real Estate Agents and Managers - Rentals" },
  { code: "7011", description: "Hotels, Motels, and Resorts" },
  { code: "7012", description: "Timeshares" },
  { code: "7032", description: "Sporting/Recreation Camps" },
  { code: "7033", description: "Trailer Parks, Campgrounds" },
  { code: "7210", description: "Laundry, Cleaning Services" },
  { code: "7211", description: "Laundries" },
  { code: "7216", description: "Dry Cleaners" },
  { code: "7217", description: "Carpet/Upholstery Cleaning" },
  { code: "7221", description: "Photographic Studios" },
  { code: "7230", description: "Barber and Beauty Shops" },
  { code: "7251", description: "Shoe Repair/Hat Cleaning" },
  { code: "7261", description: "Funeral Services, Crematories" },
  { code: "7273", description: "Dating/Escort Services" },
  { code: "7276", description: "Tax Preparation Services" },
  { code: "7277", description: "Counseling Services" },
  { code: "7278", description: "Buying/Shopping Services" },
  { code: "7296", description: "Clothing Rental" },
  { code: "7297", description: "Massage Parlors" },
  { code: "7298", description: "Health and Beauty Spas" },
  { code: "7299", description: "Miscellaneous General Services" },
  { code: "7311", description: "Advertising Services" },
  { code: "7321", description: "Consumer Credit Reporting Agencies" },
  { code: "7322", description: "Debt Collection Agency" },
  { code: "7333", description: "Commercial Photography, Art and Graphics" },
  { code: "7338", description: "Quick Copy, Repro, and Blueprint" },
  { code: "7339", description: "Secretarial Support Services" },
  { code: "7342", description: "Exterminating Services" },
  { code: "7349", description: "Cleaning and Maintenance" },
  { code: "7361", description: "Employment/Temp Agencies" },
  { code: "7372", description: "Computer Programming" },
  { code: "7375", description: "Information Retrieval Services" },
  { code: "7379", description: "Computer Repair" },
  { code: "7392", description: "Consulting, Public Relations" },
  { code: "7393", description: "Detective Agencies" },
  { code: "7394", description: "Equipment Rental" },
  { code: "7395", description: "Photo Developing" },
  { code: "7399", description: "Miscellaneous Business Services" },
  { code: "7512", description: "Automobile Rental Agency" },
  { code: "7513", description: "Truck/Utility Trailer Rentals" },
  { code: "7519", description: "Recreational Vehicle Rentals" },
  { code: "7523", description: "Parking Lots, Garages" },
  { code: "7531", description: "Auto Body Repair Shops" },
  { code: "7534", description: "Tire Retreading and Repair" },
  { code: "7535", description: "Auto Paint Shops" },
  { code: "7538", description: "Auto Service Shops" },
  { code: "7542", description: "Car Washes" },
  { code: "7549", description: "Towing Services" },
  { code: "7622", description: "Electronics Repair" },
  { code: "7623", description: "A/C, Refrigeration Repair" },
  { code: "7629", description: "Small Appliance Repair" },
  { code: "7631", description: "Watch/Jewelry Repair" },
  { code: "7641", description: "Reupholstery, Furniture Repair" },
  { code: "7692", description: "Welding Repair" },
  { code: "7699", description: "Miscellaneous Repair Shops" },
  { code: "7800", description: "Government-Owned Lotteries (US Region only)" },
  { code: "7801", description: "Government-Licensed Online Casinos (Online Gambling) (US Region only)" },
  { code: "7802", description: "Government-Licensed Horse/Dog Racing (US Region only)" },
  { code: "7829", description: "Picture/Video Production" },
  { code: "7832", description: "Motion Picture Theaters" },
  { code: "7841", description: "Video Tape Rental Stores" },
  { code: "7911", description: "Dance Halls, Studios, Schools" },
  { code: "7922", description: "Theatrical Ticket Agencies" },
  { code: "7929", description: "Bands, Orchestras" },
  { code: "7932", description: "Billiard/Pool Establishments" },
  { code: "7933", description: "Bowling Alleys" },
  { code: "7941", description: "Sports Clubs/Fields" },
  { code: "7991", description: "Tourist Attractions and Exhibits" },
  { code: "7992", description: "Public Golf Courses" },
  { code: "7993", description: "Video Amusement Game Supplies" },
  { code: "7994", description: "Video Game Arcades" },
  { code: "7995", description: "Betting/Casino Gambling" },
  { code: "7996", description: "Amusement Parks/Carnivals" },
  { code: "7997", description: "Membership Clubs" },
  { code: "7998", description: "Aquariums" },
  { code: "7999", description: "Miscellaneous Recreation Services" },
  { code: "8011", description: "Doctors" },
  { code: "8021", description: "Dentists, Orthodontists" },
  { code: "8031", description: "Osteopaths" },
  { code: "8041", description: "Chiropractors" },
  { code: "8042", description: "Optometrists, Ophthalmologist" },
  { code: "8043", description: "Opticians, Eyeglasses" },
  { code: "8044", description: "Optical Goods and Eyeglasses" },
  { code: "8049", description: "Chiropodists, Podiatrists" },
  { code: "8050", description: "Nursing/Personal Care" },
  { code: "8062", description: "Hospitals" },
  { code: "8071", description: "Medical and Dental Labs" },
  { code: "8099", description: "Medical Services" },
  { code: "8111", description: "Legal Services, Attorneys" },
  { code: "8211", description: "Elementary, Secondary Schools" },
  { code: "8220", description: "Colleges, Universities" },
  { code: "8241", description: "Correspondence Schools" },
  { code: "8244", description: "Business/Secretarial Schools" },
  { code: "8249", description: "Vocational/Trade Schools" },
  { code: "8299", description: "Educational Services" },
  { code: "8351", description: "Child Care Services" },
  { code: "8398", description: "Charitable and Social Service Organizations - Fundraising" },
  { code: "8641", description: "Civic, Social, Fraternal Associations" },
  { code: "8651", description: "Political Organizations" },
  { code: "8661", description: "Religious Organizations" },
  { code: "8675", description: "Automobile Associations" },
  { code: "8699", description: "Membership Organizations" },
  { code: "8734", description: "Testing Laboratories" },
  { code: "8911", description: "Architectural/Surveying Services" },
  { code: "8931", description: "Accounting/Bookkeeping Services" },
  { code: "8999", description: "Professional Services" }
];

// Create searchable index
export const createSicCodeSearchIndex = () => {
  return PAYARC_SIC_CODES.map(code => ({
    ...code,
    searchText: `${code.code} ${code.description}`.toLowerCase()
  }));
};

// Search function for SIC codes
export const searchSicCodes = (query: string, limit: number = 20): SicCode[] => {
  if (!query.trim()) return PAYARC_SIC_CODES.slice(0, limit);
  
  const searchTerm = query.toLowerCase();
  const searchIndex = createSicCodeSearchIndex();
  
  return searchIndex
    .filter(code => 
      code.searchText.includes(searchTerm) || 
      code.code.includes(searchTerm.toUpperCase())
    )
    .slice(0, limit)
    .map((item) => ({ code: item.code, description: item.description }));
};

// Get default SIC code (misc services)
export const getDefaultSicCode = (): SicCode => {
  return { code: "8099", description: "Medical Services" };
};